module.exports = __webpack_public_path__ + "img/share.ea2f5308.svg";